import Section1 from '@/src/components/api/Section1'
import Section2 from '@/src/components/api/Section2'
import Section3 from '@/src/components/api/Section3'
import Section4 from '@/src/components/api/Section4'
import Section5 from '@/src/components/api/Section5'
import Section6 from '@/src/components/api/Section6'
import Section7 from '@/src/components/api/Section7'

import { getApiPriceList } from '@/src/api/api'
import { useMemo } from 'react'
import Layout from 'src/components/layout'
import MetaSeo from 'src/components/layout/metaSeo'
import useGA from 'src/hooks/use_ga'
import useI18n from 'src/hooks/use_i18n'
import { CarrierInfoMarkDTO } from 'src/types'
import { carrierInfoMarkMap } from 'src/utils/carriers'
import { numberFormat } from 'src/utils/carriers_info'
import { getV5Front } from 'src/utils/server_global'
import { DEFAULT_CARRIER_INFO_MARK } from '../../constants/carrier_info_mark'

const logger = require('@/config/logger')

interface PriceRes {
  currency: 'CNY' | 'USD'
  list: {
    original: number
    price: number
    sku: string
    track: number
    unit: string
  }[]
}
interface PageProps {
  carrierInfoMark: CarrierInfoMarkDTO
  country: string | any
  totalCarriersStr: string
  priceRes: PriceRes
}

export default function Api({ carrierInfoMark, totalCarriersStr, priceRes, country }: PageProps) {
  useGA('api')
  const { activeLocale: locale } = useI18n()
  const { $t } = useI18n()
  const message = useMemo(() => $t('ResConsolePLanding.global'), [$t])
  const isChina = locale === 'zh-cn' || locale === 'zh-hk'
  const meta = {
    title: message.meta_title,
    description: message.meta_desc,
    keywords: message.meta_keyword
  }
  return (
    <>
      <MetaSeo {...meta} />
      <Layout showAllPlatform carrierInfoMark={carrierInfoMark} country={country}>
        <Section1 message={message} country={country} totalCarriersStr={totalCarriersStr} />
        <Section2 message={message} />
        <Section3 message={message} isChina={isChina} />
        <Section4 message={message} isChina={isChina} totalCarriersStr={totalCarriersStr} />
        <Section5 message={message} />
        <Section6 message={message} isChina={isChina} priceRes={priceRes} />
        <Section7 message={message} />
      </Layout>
    </>
  )
}

export async function getServerSideProps({ req, locale }) {
  try {
    const { 'cf-ipcountry': country = 'CN' } = req.headers
    logger.info('indexHeaders信息', { headers: req.headers })
    const [V5Front, carrierInfoMark, allCarriersJson, priceRes] = await Promise.all([
      getV5Front(['api'], locale),
      fetch(`https://res.17track.net/asset/carrier/info/mark.${locale}.json`)
        .then((res) => res.json())
        .catch((error) => {
          logger.error('api页面获取carrierInfoMark信息异常', { message: error.message })
          return DEFAULT_CARRIER_INFO_MARK // 兜底数据
        }),
      fetch(`https://res.17track.net/asset/carrier/info/carrier.all.json`)
        .then((res) => res.json())
        .catch((error) => {
          logger.error('api页面获取allCarriersJson数据异常', { message: error.message })
          return [] // 兜底无数据
        }),
      getApiPriceList(country)
        .then((res) => res.json())
        .catch((error) => {
          logger.error('api页面获取价格列表信息异常', { message: error.message })
          return {} // 兜底数据
        })
    ])
    logger.info('获取carrierInfoMark信息', { carrierInfoMark })
    return {
      props: {
        locale,
        V5Front,
        totalCarriersStr: numberFormat(allCarriersJson.length),
        country: country ?? 'CN',
        carrierInfoMark: carrierInfoMarkMap(carrierInfoMark),
        priceRes: priceRes?.Json || {}
      }
    }
  } catch (error: any) {
    logger.error('api页面请求异常', { message: error.message })
  }
}
